import { styled } from '@mui/material';
import CTAButton from '@components/CTAButton';

const actionButtonStyles = {
  width: '100%',
  minWidth: 0,
  minHeight: 48,
  height: 'auto',
  padding: '10px 18px',
  lineHeight: 1.25,
  textAlign: 'center',
  whiteSpace: 'normal',
  overflowWrap: 'anywhere',
};

export const Actions = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: 12,
  marginTop: 4,
  '@media (max-width: 520px)': {
    gridTemplateColumns: '1fr',
  },
});

export const Body = styled('p')({
  margin: 0,
  lineHeight: 1.5,
});

export const ActionButton = styled(CTAButton)(actionButtonStyles);

export const CancelButton = styled(CTAButton)({
  gridColumn: '1 / -1',
  justifySelf: 'end',
  padding: '6px 0',
});

export const DestructiveButton = styled(CTAButton)(
  actionButtonStyles,
  ({ theme }) => ({
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  }),
);
